"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _BaseService2 = _interopRequireDefault(require("./BaseService"));

var _querystring = _interopRequireDefault(require("querystring"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CONFIG_PATH = 'cognito';

var CognitoService = /*#__PURE__*/function (_BaseService) {
  (0, _inherits2["default"])(CognitoService, _BaseService);

  var _super = _createSuper(CognitoService);

  function CognitoService() {
    (0, _classCallCheck2["default"])(this, CognitoService);
    return _super.call(this, {
      configPath: CONFIG_PATH
    });
  }

  (0, _createClass2["default"])(CognitoService, [{
    key: "fetchTokens",
    value: function () {
      var _fetchTokens = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(data) {
        var _yield$this$config, domainName, client_id, url, tokens;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.config();

              case 2:
                _yield$this$config = _context.sent;
                domainName = _yield$this$config.domain_name;
                client_id = _yield$this$config.client_id;
                url = "https://".concat(domainName, "/oauth2/token");
                _context.next = 8;
                return this.request({
                  url: url,
                  method: 'POST',
                  headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                  },
                  data: _objectSpread({
                    client_id: client_id
                  }, data)
                });

              case 8:
                tokens = _context.sent;
                return _context.abrupt("return", {
                  id: tokens.id_token,
                  access: tokens.access_token,
                  refresh: tokens.refresh_token
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchTokens(_x) {
        return _fetchTokens.apply(this, arguments);
      }

      return fetchTokens;
    }()
  }, {
    key: "refreshToken",
    value: function refreshToken(refresh_token) {
      JSON.stringify("refreshToken called with ".concat(refresh_token));
      return this.fetchTokens({
        grant_type: 'refresh_token',
        refresh_token: refresh_token
      });
    }
  }, {
    key: "tokensFromCode",
    value: function tokensFromCode(code, redirect_uri) {
      JSON.stringify("refreshToken called with ".concat(code));
      return this.fetchTokens({
        code: code,
        grant_type: 'authorization_code',
        redirect_uri: redirect_uri
      });
    }
  }, {
    key: "oauthProviderRedirectUrl",
    value: function () {
      var _oauthProviderRedirectUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(redirect_uri) {
        var options,
            _yield$this$config2,
            domain_name,
            client_id,
            scope,
            identity_provider,
            _yield$this$config2$r,
            response_type,
            query,
            _args2 = arguments;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                _context2.next = 3;
                return this.config();

              case 3:
                _yield$this$config2 = _context2.sent;
                domain_name = _yield$this$config2.domain_name;
                client_id = _yield$this$config2.client_id;
                scope = _yield$this$config2.scope;
                identity_provider = _yield$this$config2.identity_provider;
                _yield$this$config2$r = _yield$this$config2.response_type;
                response_type = _yield$this$config2$r === void 0 ? 'code' : _yield$this$config2$r;
                query = _objectSpread({
                  client_id: client_id,
                  scope: scope,
                  identity_provider: identity_provider,
                  response_type: response_type,
                  redirect_uri: redirect_uri
                }, options);
                query.scope = query.scope.join(' ');
                return _context2.abrupt("return", "https://".concat(domain_name, "/oauth2/authorize?").concat(_querystring["default"].stringify(query)));

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function oauthProviderRedirectUrl(_x2) {
        return _oauthProviderRedirectUrl.apply(this, arguments);
      }

      return oauthProviderRedirectUrl;
    }()
  }]);
  return CognitoService;
}(_BaseService2["default"]);

exports["default"] = CognitoService;